<style scoped lang="scss">
  //.basic {
  //
  //}
  .wrap {
    width: 100%;
    display: flex;
    margin-top: 0px;
    align-items: stretch;
  }

  .left {
    width: 411px;
    height: 262px;
    margin-top: 10px;
    border: 1px solid #dcdfe6;
  }

  .item1 {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }

  .item2 {
    width: 100%;
    height: 100%;
    //border: 1px solid black;
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #303133;

        .title-t {
          margin-right: 146px;
          font-size: 16px;
        }

        .list-t {
          margin-top: 8px;

          .list-t-item {
            flex: 1;
            display: flex;
            border: 1px solid #ebeef5;
            border-left: none;
            align-items: center;
            width: 171px;
            margin-bottom: 10px;

            .tag {
              width: 4px;
              height: 50px;
            }

            .content {
              margin-left: 14px;

              .title {
                font-size: 14px;
                color: #646566;
              }

              .num {
                display: flex;
                font-size: 20px;
                color: #323233;
                justify-content: flex-start;
              }
            }
          }
        }
      }

      /*    }*/

      /*    .footer {*/
      /*      width: 100%;*/
      /*      height: 36px;*/
      font-size: 14px;
      color: #909399;
      text-align: right;
    }
  }

  .item3 {
    width: 100%;
    height: 40px;
    //border: 1px solid black;
    color: #909399;
    margin-left: 15px;
    font-size: 14px;
    margin-top: 5px;
  }

  .right {
    flex: 1;
    height: 262px;
    margin-left: 18px;
    margin-top: 30px;
    border: 1px solid #dcdfe6;
    padding: 20px 28px 46px 28px;
    box-sizing: border-box;
    display: flex;

    .item4 {
      width: 100%;
      height: 100%;

      .header {
        color: #303133;
        font-size: 16px;
      }

      #tableChart {
        width: 100%;
        height: 260px;
      }
    }
  }
</style>

<template>
  <div class="page" style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/wo_report_record_analyse"
      getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--                :ids.sync="yt.conditions.equipmentId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'"
              :ids.sync="yt.conditions.mouldId"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"></yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'"-->
            <!--                :ids.sync="yt.conditions.materialId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'"
              :ids.sync="yt.conditions.status"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{$t('sousuo')}}
            </el-button>
            <el-button
              @click="
                yt.clear({ status: [6]});
                reset();
              "
            >{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #shifoubulu="scope">
        <span v-if="scope.row.type == 0">
          {{$t('fou')}}
        </span>
        <span v-if="scope.row.type == 1">
          {{$t('shi')}}
        </span>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baogongbulu', scope.row, 'w1', beforeShowEditDialog)">
              {{$t('baogongbulu')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('buliangbulu', scope.row, 'w2')">
              {{$t('buliangbulu')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row, '/web/production/woreportrecord/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="exportExcel()"></el-button>-->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #footer_bottom>
        <!-- 这里可以在底部填写东西 -->
        <div class="wrap">

          <div>
            <div class="item1">
              <span class="icon"></span>
              <span class="txt">{{$t('fenxijieguo')}}</span>
            </div>
            <div class="left">
              <div v-if="allList.length !== 0" class="item2">
                <div class="header" style="margin-top: 10px">
                  <div class="item">
                    <div class="title-t">{{$t('zaoban')}}</div>
                    <div class="list-t">
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#67C23A;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('yibaogongliangpinshu')}}
                          </p>
                          <p class="num">
                            {{badQuantitys}}
                          </p>
                        </div>
                      </div>
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#E6A23C;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('yibaogongbuliangpinshu')}}
                          </p>
                          <p class="num">
                            {{badQuantitySums}}
                          </p>
                        </div>
                      </div>
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#F56C6C;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('buhegelu（PPM)')}}
                          </p>
                          <p class="num">
                            {{ppms}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <div class="title-t">{{$t('wanban')}}</div>
                    <div class="list-t">
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#67C23A;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('yibaogongliangpinshu')}}
                          </p>
                          <p class="num">
                            {{allBadQuantitys}}
                          </p>
                        </div>
                      </div>
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#E6A23C;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('yibaogongbuliangpinshu')}}
                          </p>
                          <p class="num">
                            {{allBadQuantitySums}}
                          </p>
                        </div>
                      </div>
                      <div class="list-t-item">
                        <div class="tag" style="background-color:#F56C6C;"></div>
                        <div class="content">
                          <p class="title">
                            {{$t('buhegelu（PPM)')}}
                          </p>
                          <p class="num">
                            {{allPpms}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item3" v-show="allList.length !== 0">{{$t('xuanzhonggongdanbuhegelu')}}（PPM):{{allPpm}}
                </div>
              </div>
              <div v-else="allList.length == 0"
                style="font-size: 16px;display: flex;justify-content: center;align-items: center;margin-top:140px;color:#606266;">
                {{$t('zanwushujv')}}
              </div>

            </div>
          </div>
          <div class="right">
            <div class="item4">
              <div class="header">
                {{$t('fenxitu')}}
              </div>
              <div v-show="allList.length == 0"
                style="font-size: 16px;display: flex;justify-content: center;align-items: center;margin-top:100px;color:#606266;">
                {{$t('zanwushujv')}}
              </div>
              <div id="tableChart"></div>
            </div>
          </div>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'web_report_bad_order_list',

    data() {
      return {
        pageSizes: '',
        totalReportCharts: null,
        allLists: [],
        list: [],
        allList: [],
        rowList: [],
        rowObject: null,
        badQuantitys: '', //已报工良品数
        badQuantitySums: '', //已报工不良品数
        ppms: '',
        allBadQuantitys: '', //已报工良品数
        allBadQuantitySums: '', //已报工不良品数
        allPpms: '',
        allPpm: '', //总ppm
        orderIds: '',
        defectCodeName: [],
        topActive: '',
        codeName: null,
        procedureName: null,
        equipmentId: null,
        equipmentList: [],
        columns: [
          {
            label: 'xuanze',
            type: 'selection'
          },
          {
            label: 'shengchangongdanhao',
            prop: 'woNo',
            width: 130
          },
          {
            label: 'ERPgongdanhao',
            prop: 'erpNo',
            width: 130
          },
          {
            label: 'gongdanzhuangtai',
            type: 'tag',
            prop: 'status',
            tags: {
              1: {
                color: '#419FFF',
                text: this.$t('xinjian')
              },
              2: {
                color: '#419FFF',
                text: this.$t('fafang')
              },
              3: {
                color: '#67C23A',
                text: this.$t('shengchanzhong')
              },
              4: {
                color: '#F56C6C',
                text: this.$t('zanting')
              },
              5: {
                color: '#67C23A',
                text: this.$t('shougongxuwangong')
              },
              6: {
                color: '#67C23A',
                text: this.$t('wangong')
              },
              7: {
                color: '#909399',
                text: this.$t('guanbi')
              },
              8: {
                color: '#E6A23C',
                text: this.$t('yidiaobo')
              }
            }
          },
          {
            label: 'shebeimingcheng',
            prop: 'equipmentName',
            width: 130
          },
          {
            label: 'mujubianhao',
            prop: 'mouldNo',
            width: 130
          },
          {
            label: 'mujumingcheng',
            prop: 'mouldName',
            width: 130
          },
          {
            label: 'chanpinbianma',
            prop: 'materialCode',
            width: 130
          },
          {
            label: 'chanpinmingcheng',
            prop: 'materialName',
            width: 130
          },
          {
            label: 'gongxumiaoshu',
            prop: 'procedureDesc',
            width: 130
          },
          {
            label: 'jihuashuliang',
            prop: 'planQuantity'
          },
          {
            label: 'baogongshuliang',
            prop: 'quantity',
            width: 130
          },
          {
            label: 'yibaogongliangpinshu',
            prop: 'finishGoodQuantity',
            width: 130
          },

          {
            label: 'yibaogongbuliangpinshu',
            prop: 'badQuantity',
            width: 130
          },
          {
            label: 'shengyushengchanshuliang',
            prop: 'leftProductionQuantity',
            width: 130
          }
        ]
      };
    },
    created() {
      this.resize();
      setTimeout(() => {
        this.yt.get(1, this.beforeGet);
        // this.$set(this.yt.editObj, 'selected', false)
        console.log('selected', this.yt.conditions);
        this.yt.conditions = {
          status: ['6']
        };
      }, 300);
    },
    mounted() {
      this.resize();
      this.utils.event_hub.$on('RESIZE', () => {
        this.resize();
      });
      this.getAnalyseSummary();
    },
    activated() {
      this.resize();
    },
    methods: {
      resize() {
        //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
        setTimeout(() => {
          this.totalReportCharts.resize();
          // this.totalReportCharts
          // if (this.totalReportCharts) {
          //   this.totalReportCharts.resize();
          // }
        }, 500);
      },
      reset() {
        this.drawTableChart();
        this.yt.conditions = {
          status: ['6']
        };
        this.yt.get(1, this.beforeGet);
        this.badQuantitys = '';
        this.badQuantitySums = '';
        this.ppms = '';
        this.allBadQuantitys = '';
        this.allBadQuantitySums = '';
        this.allPpms = '';
        this.allPpm = '';
      },
      beforeGet(params) {
        params['status'] = ['6'];
        return params;
      },
      selectionChange(items) {
        this.allLists = items;
        this.orderIds = items.map(item => {
          return item.id;
        });
        this.drawTableChart();
        this.getAnalyseSummary();
      },
      getAnalyseSummary() {
        let requestParam = {
          id: this.orderIds.join(',')
        };
        return this.http.get('/web/report/page/wo_report_record_analyse_summary?' + this.qs.stringify(requestParam)).then(response => {
          console.log('items', response.data.rows);
          this.allList = response.data.rows;
          let items = response.data.rows;
          for (let i = 0; i < items.length; i++) {
            if (items[i].shiftName == '早班') {
              //已报工良品数
              console.log('已报工良品数', items[i]['badQuantity']);
              if (items[i].badQuantity !== null && items[i].badQuantity !== undefined) {
                this.badQuantitys = items[i].badQuantity.toFixed(0);
              }
              //已报工不良品数
              if (items[i].badQuantitySum !== null && items[i].badQuantitySum !== undefined) {
                this.badQuantitySums = items[i].badQuantitySum.toFixed(0);
              }
              //不合格率（PPM)
              if (items[i].ppm !== null && items[i].ppm !== undefined) {
                this.ppms = items[i].ppm.toFixed(0);
              }
            }

            if (items[i].shiftName == '晚班') {
              //已报工良品数
              console.log('已报工良品数', items[i]['badQuantity']);
              if (items[i].badQuantity !== null && items[i].badQuantity !== undefined) {
                this.allBadQuantitys = items[i].badQuantity.toFixed(0);
              }
              //已报工不良品数
              if (items[i].badQuantitySum !== null && items[i].badQuantitySum !== undefined) {
                this.allBadQuantitySums = items[i].badQuantitySum.toFixed(0);
              }
              //不合格率（PPM)
              if (items[i].ppm !== null && items[i].ppm !== undefined) {
                this.allPpms = items[i].ppm.toFixed(0);
              }
            }
          }
          // 不合格率（PPM）：已报工不良品数/已报工良品数*1000000,取整数。
          let allBadQuantitys = Number(this.badQuantitySums) + Number(this.allBadQuantitySums);
          let allQuantitys = Number(this.badQuantitys) + Number(this.allBadQuantitys);
          this.allPpm = ((allBadQuantitys / allQuantitys) * 1000000).toFixed(0);
          this.drawTableChart(response.data.rows);
        });
      },

      drawTableChart(data = []) {
        this.resize();

        this.resize();
        if (!document.getElementById('tableChart')) {
          return;
        }
        this.totalReportCharts = this.echarts.getInstanceByDom(document.getElementById('tableChart'));
        if (this.totalReportCharts == null) {
          this.totalReportCharts = this.echarts.init(document.getElementById('tableChart'));
        }
        // this.totalReportCharts = this.echarts.getInstanceByDom(document.getElementById('tableChart'));
        // if (this.totalReportCharts == null) {
        //   this.totalReportCharts = this.echarts.init(document.getElementById('tableChart'));
        // }
        // totalReportCharts
        if (data.length === 0) {
          this.totalReportCharts.dispose();
          return true;
        }
        const xAxis = [];
        const badQuantity = [];
        const badQuantitySum = [];
        const ppm = [];
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            if (!xAxis.includes(data[i]['shiftName'])) {
              xAxis.push(data[i]['shiftName']);
            }
            badQuantity.push(data[i]['badQuantity'].toFixed(0));
            badQuantitySum.push(data[i]['badQuantitySum'].toFixed(0));
            ppm.push(data[i]['ppm'].toFixed(0));
          }
        }
        console.log('badQuantity', badQuantity);
        console.log('badQuantitySum', badQuantitySum);
        console.log('ppm', ppm);
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            left: 'center',
            top: '0%',
            textStyle: {
              color: '#909399',
              fontSize: 12
            },
            itemWidth: 15,
            itemHeight: 10,
            itemGap: 25
          },
          grid: {
            left: '0',
            right: '0',
            bottom: '60',
            top: '16%',
            containLabel: true
          },
          xAxis: {
            show: true,
            type: 'category',
            nameLocation: 'end',
            nameTextStyle: {
              fontSize: 14
            },
            inverse: false,
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#000',
                width: 1
              }
            },
            axisTick: {
              show: true,
              alignWithLabel: false,
              interval: 'auto',
              inside: false,
              length: 5,
              lineStyle: {
                type: 'solid',
                width: 1,
                color: '#909399'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                width: 1,
                color: '#909399'
              }
            },
            axisLabel: {
              margin: 8,
              interval: 'auto',
              rotate: 0,
              fontSize: 14,
              color: '#909399'
            },
            data: xAxis
          },
          yAxis: [
            {
              type: 'value',
              name: '数量',
              nameLocation: 'start'
            }
          ],
          series: [
            {
              name: '已报工良品数',
              type: 'bar',
              barWidth: '12px',
              itemStyle: {
                normal: {
                  color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#419FFF'
                    },
                    {
                      offset: 1,
                      color: 'rgba(227, 227, 227,0.3)'
                    }
                  ]),
                  barBorderRadius: 6
                }
              },
              barGap: '80%',
              barCategoryGap: '100%',
              data: badQuantity
            },
            {
              name: '已报工不良品数',
              type: 'bar',
              barWidth: '12px',
              itemStyle: {
                normal: {
                  color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#5C41FF'
                    },
                    {
                      offset: 1,
                      color: 'rgba(227, 227, 227,0.3)'
                    }
                  ]),
                  barBorderRadius: 6
                }
              },
              barGap: '80%',
              barCategoryGap: '100%',
              data: badQuantitySum
            },
            {
              name: '不合格率(PPM)',
              type: 'line',
              symbol: 'none',
              // tooltip: {
              //   valueFormatter: function(value) {
              //     return value + ' %';
              //   }
              // },
              lineStyle: {
                color: '#E6A23C'
              },
              itemStyle: {
                color: '#e6a23c'
              },
              data: ppm
            }
          ]
        };
        this.totalReportCharts.setOption(option);
      }
    }
  };
</script>
